import * as React from 'react';
import { PopupWindow } from '../sharedcomponents/PopupWindow';
import { RCUtils } from './../../RCUtils';
//import { DateTime } from 'react-datetime-bootstrap';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Formatters from '../../actions/Formatters';
import $ from 'jquery';
import DateFormat from 'dateformat';
import * as Autosuggest from 'react-autosuggest';
import * as RCNGWindow from '../sharedcomponents/ConfirmationWindow';
import Item from 'antd/lib/list/Item';
import { NewBookingCreate } from '../routecomponents/NewBookingCreate'
import { NewBookingEdit } from '../routecomponents/NewBookingEdit'
import { title } from 'process';
import lodashfilter from 'lodash/filter';
import uniq from 'lodash/uniq';
import ReactTooltip from 'react-tooltip';
import forEach from 'lodash/forEach';
import { ViewBooking } from '../routecomponents/ViewBooking';
var Config: any = require('../../Config.json');
interface BookingState {
    BookingDetails: server.BookingDetails;
    BookingReefers: server.BookingSearchDetails;
    //CommonBookingData: server.CommonBookingData;
    rowData: server.bookingReefer[];
    suggestionsBookingNumber: any[];
    BookingList: any[];
    isBookingEdit: boolean;
    isAllBooking: number;
    BookingDesc: any
    RefVessels: server.vesselsList[];
    suggestionsVesselId: any[],
    suggestionsVoyage: any[],
    suggestionsCalls: any[],
    ArrsuggestionsVesselId: any[],
    ArrsuggestionsVoyage: any[],
    ArrsuggestionsCalls: any[],
    CopyBookingNumber: any;
    ReeferforCreate: any;
    UnitmasterId: any;
    formname: any;
    //PreferenceDTTM: any;
    isViewOnly: boolean;
}
var emptyBookingDetails: server.BookingDetails = {
    Shipper: '', Consignee: '', ShipperCode: '', POR: '', POL: '', POD: '',
    VesselETD: null, //DateFormat(new Date(), 'mm/dd/yyyy HH:MM')
     VesselETA: null,//DateFormat(new Date(), 'mm/dd/yyyy HH:MM')
    BLNumber: '', ContractParty: '', Consolidation: '',
    Agent: '', VesselCode: '', VoyageNumber: '', Call: '', Forwarder: '', Notify: '', BookingNumber: '', DEL: '', IsVVCModified: false,
    SelectedVesselCD: '',
    SelectedCall: '',
    SelectedVoyage: '',
    ArrSelectedVesselCD: '',
    ArrSelectedCall: '',
    ArrSelectedVoyage: '', userInput: 0, CustomerAccessGroupIDLoaded: '',
    BKCustomer:''

};
var emptyBookingReefers: server.BookingSearchDetails = {
    BookingReefers: '', SelectedBookingReefers: '', ReeferwithUnitID: [],BookingNumber:[]
}
var methodResult = true;
var TempBooking: any;
var self;
export class SpecificBookingDetails extends React.Component<any, BookingState> {
    myRequest: any;
    constructor(props: any) {
        super(props);
        emptyBookingDetails = {
            Shipper: '', Consignee: '', ShipperCode: '', POR: '', POL: '', POD: '',
            VesselETD: null,//DateFormat(new Date(), 'mm/dd/yyyy HH:MM'),
            VesselETA: null,//DateFormat(new Date(), 'mm/dd/yyyy HH:MM'),
            BLNumber: '', ContractParty: '', Consolidation: '',
            Agent: '', VesselCode: '', VoyageNumber: '', Call: '', Forwarder: '', Notify: '', BookingNumber: '', DEL: '', IsVVCModified: false,
            SelectedVesselCD: '',
            SelectedCall: '',
            SelectedVoyage: '',
            ArrSelectedVesselCD: '',
            ArrSelectedCall: '',
            ArrSelectedVoyage: '', userInput: 0, CustomerAccessGroupIDLoaded: '',
            BKCustomer:''
        };
        emptyBookingReefers = {
            BookingReefers: '', SelectedBookingReefers: '', ReeferwithUnitID: [],BookingNumber:[]
        }
        var bookingDesc: any;
        if (!this.props.formState.isEdit && this.props.formState.BookingType == "New Booking")
            bookingDesc = 'Enter the booking data. This data applies to all of the booking’s reefers.';
        else if(this.props.formState.isEdit)
            bookingDesc = 'Update the booking data. This data applies to all of the booking’s reefers.';
        else
             bookingDesc = 'View the booking data. This data applies to all of the booking’s reefers.';
        this.state = {
            BookingDetails: emptyBookingDetails, BookingReefers: emptyBookingReefers, rowData: [], suggestionsBookingNumber: [], BookingList: [], isBookingEdit: this.props.formState.isEdit, isAllBooking: this.props.formState.BookingCount,
            BookingDesc: bookingDesc //this.props.formState.isEdit ? 'Update the booking data. This data applies to all of the booking’s reefers.' : 'Enter the booking data. This data applies to all of the booking’s reefers.'
            , RefVessels: [], suggestionsVesselId: [], suggestionsVoyage: [], suggestionsCalls: [], ArrsuggestionsVesselId: [], ArrsuggestionsVoyage: [], ArrsuggestionsCalls: [], CopyBookingNumber: '', formname: this.props.formState.formname, ReeferforCreate: this.props.formState.ReeferforCreate, UnitmasterId: this.props.formState.UnitmasterId, isViewOnly: this.props.formState.isViewOnly
        };
        //if (this.props.formState.BookingCount == 0) {
        //    $('#globalLoader').show();
        //    var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/GetAllBookings')
        //    fetch(request)
        //        .then(RCUtils.handleError)
        //        .then(response => response.json() as Promise<server.USP_BookingCurrentConditionUI_Result[]>)
        //        .then(data => {
        //            $('#globalLoader').hide();
        //            if (data.length > 0) {
        //                var BookingNumber = data.map(fence => fence.BookingNumber);
        //                this.setState({
        //                    BookingList: data,
        //                    suggestionsBookingNumber: BookingNumber,
        //                    isAllBooking:1
        //                });
        //            }
        //        });
        //}
        //else {
        //    var BookingNumber = this.props.formState.AllBooking.map(fence => fence.BookingNumber);
        //    this.setState({
        //        BookingList: this.props.formState.AllBooking,
        //        suggestionsBookingNumber: BookingNumber
        //    });
        //}
        //getVVCInfo() {
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/common/Getvessels')
        RCUtils.fetchRetry(request)
            .then(RCUtils.handleResponse)
            .then(response => response.json() as Promise<any>)
            .then(data => {
                if (data.length > 0) {
                    this.setState({ RefVessels: data });
                }
            });
        // }
        self = this;
    }
    componentDidMount() {
        $(document).ready(function () {
            //var preloader = document.getElementById("preloader");
            //preloader.classList.add("hidden");
            $('#BookingSearch').bind('keypress', function (e) {
                if (e.keyCode === 13) {
                    $('#button_login').trigger('click');
                }
            });
        });
        if (this.props.formState != null) {
            var BookingInfoDetails = emptyBookingDetails;

            BookingInfoDetails.Shipper = this.props.formState.BookingDetails.Shipper;
            BookingInfoDetails.Consignee = this.props.formState.BookingDetails.Consignee;
            BookingInfoDetails.ShipperCode = this.props.formState.BookingDetails.ShipperCode;
            BookingInfoDetails.POR = this.props.formState.BookingDetails.POR;
            BookingInfoDetails.POL = this.props.formState.BookingDetails.POL;
            BookingInfoDetails.POD = this.props.formState.BookingDetails.POD;
            BookingInfoDetails.VesselETD = this.props.formState.BookingDetails.VesselETD != null ? DateFormat(new Date(this.props.formState.BookingDetails.VesselETD), 'mm/dd/yyyy HH:MM:ss') : null;
            BookingInfoDetails.VesselETA = this.props.formState.BookingDetails.VesselETA != null ? DateFormat(new Date(this.props.formState.BookingDetails.VesselETA), 'mm/dd/yyyy HH:MM:ss') : null;
            BookingInfoDetails.BLNumber = this.props.formState.BookingDetails.BLNumber;
            BookingInfoDetails.ContractParty = this.props.formState.BookingDetails.ContractParty;
            BookingInfoDetails.Consolidation = this.props.formState.BookingDetails.Consolidation;
            BookingInfoDetails.Agent = this.props.formState.BookingDetails.Agent;
            BookingInfoDetails.VesselCode = this.props.formState.BookingDetails.VesselCode;
            BookingInfoDetails.VoyageNumber = this.props.formState.BookingDetails.VoyageNumber;
            BookingInfoDetails.Call = this.props.formState.BookingDetails.Call;
            BookingInfoDetails.Forwarder = this.props.formState.BookingDetails.Forwarder;
            BookingInfoDetails.Notify = this.props.formState.BookingDetails.Notify;
            BookingInfoDetails.BookingNumber = this.props.formState.BookingDetails.BookingNumber;
            BookingInfoDetails.DEL = this.props.formState.BookingDetails.DEL;
            BookingInfoDetails.SelectedVesselCD = this.props.formState.BookingDetails.SelectedVesselCD;
            BookingInfoDetails.SelectedCall = this.props.formState.BookingDetails.SelectedCall;
            BookingInfoDetails.SelectedVoyage = this.props.formState.BookingDetails.SelectedVoyage;
            BookingInfoDetails.ArrSelectedVesselCD = this.props.formState.BookingDetails.ArrSelectedVesselCD;
            BookingInfoDetails.ArrSelectedCall = this.props.formState.BookingDetails.ArrSelectedCall;
            BookingInfoDetails.ArrSelectedVoyage = this.props.formState.BookingDetails.ArrSelectedVoyage;
            BookingInfoDetails.userInput = this.props.formState.BookingDetails.userInput;
            BookingInfoDetails.IsVVCModified = this.props.formState.BookingDetails.IsVVCModified;
            BookingInfoDetails.BKCustomer = this.props.formState.BookingDetails.BKCustomer;
            var BookingReefersDetails = emptyBookingReefers;
            BookingReefersDetails.BookingReefers = this.props.formState.BookingReefers.BookingReefers;
            BookingReefersDetails.SelectedBookingReefers = this.props.formState.BookingReefers.SelectedBookingReefers;
            BookingReefersDetails.ReeferwithUnitID = this.props.formState.BookingReefers.ReeferwithUnitID;
            BookingReefersDetails.BookingNumber = this.props.formState.BookingReefers.BookingNumber;
            this.setState({ BookingDetails: BookingInfoDetails, BookingReefers: BookingReefersDetails, CopyBookingNumber: this.props.formState.CopyBookingNumber, rowData: self.props.formState.rowData });
            TempBooking = this.props.formState.BookingDetails.BookingNumber;
        }
    }
    componentWillReceiveProps(nextProps: any) {
        var BookingInfoDetails = emptyBookingDetails;
        BookingInfoDetails.Shipper = nextProps.formState.BookingDetails.Shipper;
        BookingInfoDetails.Consignee = nextProps.formState.BookingDetails.Consignee;
        BookingInfoDetails.ShipperCode = nextProps.formState.BookingDetails.ShipperCode;
        BookingInfoDetails.POR = nextProps.formState.BookingDetails.POR;
        BookingInfoDetails.POL = nextProps.formState.BookingDetails.POL;
        BookingInfoDetails.POD = nextProps.formState.BookingDetails.POD;
        BookingInfoDetails.VesselETD = DateFormat(new Date(nextProps.formState.BookingDetails.VesselETD), 'mm/dd/yyyy HH:MM:ss');
        BookingInfoDetails.VesselETA = DateFormat(new Date(nextProps.formState.BookingDetails.VesselETA), 'mm/dd/yyyy HH:MM:ss');
        BookingInfoDetails.BLNumber = nextProps.formState.BookingDetails.BLNumber;
        BookingInfoDetails.ContractParty = nextProps.formState.BookingDetails.ContractParty;
        BookingInfoDetails.Consolidation = nextProps.formState.BookingDetails.Consolidation;
        BookingInfoDetails.Agent = nextProps.formState.BookingDetails.Agent;
        BookingInfoDetails.VesselCode = nextProps.formState.BookingDetails.VesselCode;
        BookingInfoDetails.VoyageNumber = nextProps.formState.BookingDetails.VoyageNumber;
        BookingInfoDetails.Call = nextProps.formState.BookingDetails.Call;
        BookingInfoDetails.Forwarder = nextProps.formState.BookingDetails.Forwarder;
        BookingInfoDetails.Notify = nextProps.formState.BookingDetails.Notify;
        BookingInfoDetails.DEL = nextProps.formState.BookingDetails.DEL;
        BookingInfoDetails.SelectedVesselCD = nextProps.formState.BookingDetails.SelectedVesselCD;
        BookingInfoDetails.SelectedCall = nextProps.formState.BookingDetails.SelectedCall;
        BookingInfoDetails.SelectedVoyage = nextProps.formState.BookingDetails.SelectedVoyage;
        BookingInfoDetails.ArrSelectedVesselCD = nextProps.formState.BookingDetails.ArrSelectedVesselCD;
        BookingInfoDetails.ArrSelectedCall = nextProps.formState.BookingDetails.ArrSelectedCall;
        BookingInfoDetails.ArrSelectedVoyage = nextProps.formState.BookingDetails.ArrSelectedVoyage;
        BookingInfoDetails.userInput = nextProps.formState.BookingDetails.userInput;
        BookingInfoDetails.IsVVCModified = nextProps.formState.BookingDetails.IsVVCModified;
        BookingInfoDetails.BKCustomer = nextProps.formState.BookingDetails.BKCustomer;
        BookingInfoDetails.BookingNumber = nextProps.formState.BookingDetails.BookingNumber
        this.setState({ BookingDetails: BookingInfoDetails });
    }
    static NextScreen() {
        if (self.state.BookingDetails.BookingNumber == '' || self.state.BookingDetails.BookingNumber == undefined)
            PopupWindow.showErrorMessage("Alert", "Please Enter Booking Number.");
        else if (self.HasNonPrintableASCII(self.state.BookingDetails.BookingNumber))
            PopupWindow.showErrorMessage("Alert", "Please Enter Valid Booking Number.");
        else if (self.state.BookingDetails.Shipper != '' && self.state.BookingDetails.Shipper != null && self.HasNonPrintableASCII(self.state.BookingDetails.Shipper))
            PopupWindow.showErrorMessage("Alert", "Please Enter Valid Shipper.");
        else if (self.state.BookingDetails.ShipperCode != '' && self.state.BookingDetails.ShipperCode != null && self.HasNonPrintableASCII(self.state.BookingDetails.ShipperCode))
            PopupWindow.showErrorMessage("Alert", "Please Enter Valid Shipper Code.");
        else if (self.state.BookingDetails.POR != '' && self.state.BookingDetails.POR != null && self.HasNonPrintableASCII(self.state.BookingDetails.POR))
            PopupWindow.showErrorMessage("Alert", "Please Enter Valid POR.");
        else if (self.state.BookingDetails.POL != '' && self.state.BookingDetails.POL != null && self.HasNonPrintableASCII(self.state.BookingDetails.POL))
            PopupWindow.showErrorMessage("Alert", "Please Enter Valid POL.");
        else if (self.state.BookingDetails.POD != '' && self.state.BookingDetails.POD != null && self.HasNonPrintableASCII(self.state.BookingDetails.POD))
            PopupWindow.showErrorMessage("Alert", "Please Enter Valid PLD.");
        else if (self.state.BookingDetails.BLNumber != '' && self.state.BookingDetails.BLNumber != null && self.HasNonPrintableASCII(self.state.BookingDetails.BLNumber))
            PopupWindow.showErrorMessage("Alert", "Please Enter Valid BOL No.");
        else if (self.state.BookingDetails.ContractParty != '' && self.state.BookingDetails.ContractParty != null && self.HasNonPrintableASCII(self.state.BookingDetails.ContractParty))
            PopupWindow.showErrorMessage("Alert", "Please Enter Valid Contractor.");
        else if (self.state.BookingDetails.Consolidation != '' && self.state.BookingDetails.Consolidation != null && self.HasNonPrintableASCII(self.state.BookingDetails.Consolidation))
            PopupWindow.showErrorMessage("Alert", "Please Enter Valid Consolidator.");
        else if (self.state.BookingDetails.Agent != '' && self.state.BookingDetails.Agent != null && self.HasNonPrintableASCII(self.state.BookingDetails.Agent))
            PopupWindow.showErrorMessage("Alert", "Please Enter Valid Carrier Agent.");
        else if (self.state.BookingDetails.VesselCode != '' && self.state.BookingDetails.VesselCode != null && self.HasNonPrintableASCII(self.state.BookingDetails.VesselCode))
            PopupWindow.showErrorMessage("Alert", "Please Enter Valid Vessel Code.");
        else if (self.state.BookingDetails.VoyageNumber != '' && self.state.BookingDetails.VoyageNumber != null && self.HasNonPrintableASCII(self.state.BookingDetails.VoyageNumber))
            PopupWindow.showErrorMessage("Alert", "Please Enter Valid Voyage Number.");
        else if (self.state.BookingDetails.Call != '' && self.state.BookingDetails.Call != null && self.HasNonPrintableASCII(self.state.BookingDetails.Call))
            PopupWindow.showErrorMessage("Alert", "Please Enter Valid Call.");
        else if (self.state.BookingDetails.Forwarder != '' && self.state.BookingDetails.Forwarder != null && self.HasNonPrintableASCII(self.state.BookingDetails.Forwarder))
            PopupWindow.showErrorMessage("Alert", "Please Enter Valid Forwarder.");
        else if (self.state.BookingDetails.Notify != '' && self.state.BookingDetails.Notify != null && self.HasNonPrintableASCII(self.state.BookingDetails.Notify))
            PopupWindow.showErrorMessage("Alert", "Please Enter Valid Notify.");
        else if (self.state.BookingDetails.DEL != '' && self.state.BookingDetails.DEL != null && self.HasNonPrintableASCII(self.state.BookingDetails.DEL))
            PopupWindow.showErrorMessage("Alert", "Please Enter Valid DEL.");
        else if (self.state.BookingDetails.BKCustomer != '' && self.state.BookingDetails.BKCustomer != null && self.HasNonPrintableASCII(self.state.BookingDetails.BKCustomer))
            PopupWindow.showErrorMessage("Alert", "Please Enter Valid Customer.");
        //var isfound = self.state.BookingList.filter(x => x.BookingNumber.toLowerCase() == self.state.BookingDetails.BookingNumber.toLowerCase());
        //const { SelectedVesselCD, SelectedVoyage, SelectedCall, ArrSelectedVesselCD, ArrSelectedVoyage, ArrSelectedCall } = self.state.BookingDetails;
        //const { DepartingVVC, ArrivingVVC, VesselCd, LifecycleCd } = isfound[0];
        //var PrevDepartingVoyage = DepartingVVC.split('-')[0].trim();
        //var PrevDepartingCall = DepartingVVC.split('-')[1].trim();
        //var PrevArrivalVoyage = ArrivingVVC.split('-')[0].trim();
        //var PrevArrivalCall = ArrivingVVC.split('-')[1].trim();

        //var currentdepartingVVC = VesselCd + ',' + PrevDepartingVoyage + ',' + PrevDepartingCall;
        //var currentarrivalVVC = (PrevArrivalVoyage != '' ? VesselCd : '') + ',' + PrevArrivalVoyage + ',' + PrevArrivalCall;
        //var chosenDepartingVVC = SelectedVesselCD + ',' + SelectedVoyage + ',' + SelectedCall;
        //var chosenArrivalVVC = ArrSelectedVesselCD + ',' + ArrSelectedVoyage + ',' + ArrSelectedCall;
        //
        ////if ((LifecycleCd == 'C' || LifecycleCd == null) && chosenDepartingVVC == ',,')
        //if (LifecycleCd == 'C' || LifecycleCd == null)
        //    currentdepartingVVC = ',,';
        ////if ((LifecycleCd == 'C' || LifecycleCd == null) && chosenArrivalVVC == ',,')
        //if (LifecycleCd == 'C' || LifecycleCd == null)
        //    currentarrivalVVC = ',,';

        //if (currentdepartingVVC != chosenDepartingVVC || currentarrivalVVC != chosenArrivalVVC)
        //    self.state.BookingDetails.IsVVCModified = true;
        //else
        //    self.state.BookingSystem.IsVVCModified = false;//RCNG-139

        else if (self.state.isBookingEdit && self.state.isViewOnly == false) {
            //if (self.state.BookingReefers.SelectedBookingReefers == "" || self.state.BookingReefers.SelectedBookingReefers == null) {
            //    $('#globalLoader').show();
            //    var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/GetbookingReefersUI?BookingNumber=' + self.state.BookingDetails.BookingNumber)
            //    fetch(request)
            //        .then(RCUtils.handleError)
            //        .then(response => response.json() as Promise<String>)
            //        .then(data => {
            //            $('#globalLoader').hide();
            //            if (data != null && data != undefined && data != '') {
            //                var BookingReefersData = emptyBookingReefers;
            //                BookingReefersData.BookingReefers = data.toString();
            //                BookingReefersData.SelectedBookingReefers = data.toString();
            //                self.setState({ BookingReefers: BookingReefersData }, () => {
            //                    self.props.renderWizardPage(2, self.state, 1);
            //                });
            //            }
            //        });
            //}
            //else {
            //    self.props.renderWizardPage(2, self.state, 1);
            //}
            //self.ValidateVVCandSubmitBooking();
            if ((self.state.BookingReefers.SelectedBookingReefers == "" || self.state.BookingReefers.SelectedBookingReefers == null) && self.state.isViewOnly == false) {
                NewBookingEdit.UpdateButtonStyle(false);//RCNG-925
            }
            self.props.renderWizardPage(2, self.state, 1);
        }
        //else if (self.state.CopyBookingNumber != "" && self.state.BookingList.length > 0) {
        //self.props.renderWizardPage(2, self.state, 1);
        //}
        else if (self.state.isViewOnly) {
            self.props.renderWizardPage(4, self.state, 1);
        }
        else {
            self.ValidateBooking()
            //if (self.state.BookingReefers.SelectedBookingReefers == "" || self.state.BookingReefers.SelectedBookingReefers == null) {
            //    NewBookingCreate.UpdateButtonStyle(true);
            //}
            //self.props.renderWizardPage(2, self.state, 1);
        }

    }
    CopyData() {
        var isfound = this.state.BookingList.filter(x => x.BookingNumber.toLowerCase() == self.state.CopyBookingNumber.toLowerCase());
        var BookingInfoDetails = emptyBookingDetails;
        BookingInfoDetails.Shipper = isfound[0].Shipper;
        BookingInfoDetails.Consignee = isfound[0].Consignee;
        BookingInfoDetails.ShipperCode = isfound[0].ShipperCode;
        BookingInfoDetails.POR = isfound[0].POR;
        BookingInfoDetails.POL = isfound[0].POL;
        BookingInfoDetails.POD = isfound[0].POD;
        BookingInfoDetails.VesselETD = isfound[0].VesselETD != null ? DateFormat(new Date(isfound[0].VesselETD), 'mm/dd/yyyy HH:MM:ss') : null;
        BookingInfoDetails.VesselETA = isfound[0].VesselETA != null ? DateFormat(new Date(isfound[0].VesselETA), 'mm/dd/yyyy HH:MM:ss') : null;
        BookingInfoDetails.BLNumber = isfound[0].BLNumber;
        BookingInfoDetails.ContractParty = isfound[0].ContractParty;
        BookingInfoDetails.Consolidation = isfound[0].Consolidation;
        BookingInfoDetails.Agent = isfound[0].Agent;
        BookingInfoDetails.VesselCode = isfound[0].VesselCode;
        BookingInfoDetails.VoyageNumber = isfound[0].VoyageNumber;
        BookingInfoDetails.Call = isfound[0].Call;
        BookingInfoDetails.Forwarder = isfound[0].Forwarder;
        BookingInfoDetails.Notify = isfound[0].Notify;
        BookingInfoDetails.DEL = isfound[0].DEL;
        BookingInfoDetails.BKCustomer = isfound[0].BKCustomer;
        if (isfound[0].LifecycleCd == 'L' || isfound[0].LifecycleCd == 'R' || isfound[0].LifecycleCd == 'D' || isfound[0].LifecycleCd == 'P') {
            var departingVVC = isfound[0].DepartingVVC.split('-');
            var depVoyage = departingVVC[0].trim().length > 0 ? departingVVC[0].trim() : '';
            var depCall = departingVVC[1].trim().length > 0 ? departingVVC[1].trim() : '';
            var arrivingVVC = isfound[0].ArrivingVVC.split('-');
            var arrVoyage = arrivingVVC[0].trim().length > 0 ? arrivingVVC[0].trim() : '';
            var arrCall = arrivingVVC[1].trim().length > 0 ? arrivingVVC[1].trim() : '';

            BookingInfoDetails.SelectedVoyage = depVoyage;
            BookingInfoDetails.SelectedCall = depCall;
            BookingInfoDetails.SelectedVesselCD = depVoyage != '' ? isfound[0].VoyageVesselCd : '';
            BookingInfoDetails.ArrSelectedVesselCD = arrVoyage != '' ? isfound[0].VoyageVesselCd : '';
            BookingInfoDetails.ArrSelectedVoyage = arrVoyage;
            BookingInfoDetails.ArrSelectedCall = arrCall;
        }
        var BookingReefersData = emptyBookingReefers;
        BookingReefersData.BookingReefers = this.state.BookingList.map(x => x.ReeferID).toString();
        BookingReefersData.SelectedBookingReefers = this.state.BookingList.map(x => x.ReeferID).toString();
        BookingReefersData.ReeferwithUnitID = this.state.BookingList.map(x => x.ReeferwithUnitID);
        var gridData = [];
        forEach(this.state.BookingList, function (bookingItem) {
            
            if (bookingItem != "" && bookingItem != null) {

                var item = {
                    action: '', reeferId: bookingItem.ReeferID, cargoCare: bookingItem.CCProfileName, accessCodes: bookingItem.CustomerAccessGroupID, bookedTemperature: bookingItem.BookedTemperature,
                    bookedTemperatureQualifier: bookingItem.BookedTemperatureQualifier, bookedTemperatureMin: bookingItem.BookedTemperatureMin, bookedTemperatureMax: bookingItem.BookedTemperatureMax,
                    humidity: bookingItem.HumiditySetpoint, commodity: bookingItem.Commodity, STCC: bookingItem.STCC, HS: bookingItem.HSCode, gensetId: bookingItem.GensetId, ventSetting: bookingItem.VentSetting,
                    HVFlag: bookingItem.HighValueFlag, serviceLevel: bookingItem.ServiceLevel, CAFlag: bookingItem.CAFlag, O2Setpoint: bookingItem.O2Setpoint, O2SetpointMin: bookingItem.O2SetpointMin, O2SetpointMax: bookingItem.O2SetpointMax,
                    CO2Setpoint: bookingItem.CO2Setpoint, CO2SetpointMin: bookingItem.CO2SetpointMin, CO2SetpointMax: bookingItem.CO2SetpointMax, CTFlag: bookingItem.CTFlag,
                    CTDays: bookingItem.CTDays, USDAMaxTemperature: bookingItem.USDAMaxTemperature, postCTTemperature: bookingItem.PostCTTemperature, postCTTemperatureDeviation: bookingItem.PostCTTemperatureDeviation, postCTVentSetting: bookingItem.PostCTVentSetting,
                    UnitMasterId: bookingItem.UnitMasterID, CustomerAccessGroupIdsStr: ''
                };
                gridData.push(item);
            }
        });
        this.setState({ BookingDetails: BookingInfoDetails, BookingReefers: BookingReefersData, rowData: gridData }, () => { this.EditPopupMessage() });

    }
    CopyBookingData() {

        if (self.state.CopyBookingNumber == '' || self.state.CopyBookingNumber == undefined)
            PopupWindow.showErrorMessage("Alert", "Please Enter Booking Number to Copy.");
        else if (self.state.CopyBookingNumber != null && self.state.CopyBookingNumber != '') {
            $('#globalLoader').show();
            var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/GetbookingDataByNumber?BookingNumber=' + self.state.CopyBookingNumber.toString())
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json() as Promise<server.BookingDataByNumber[]>)
                .then(data => {
                    $('#globalLoader').hide();

                    if (data != null && data != undefined && data.length > 0) {

                        this.setState({ BookingList: data }, () => { this.CopyData(); });
                    }
                    //latest Change
                    else {
                        PopupWindow.showErrorMessage("Alert", "Booking " + self.state.CopyBookingNumber + " not found.");
                        return;
                    }

                });
        }
    }
    ValidateVVCandSubmitBooking() {
        
        const { SelectedVesselCD, SelectedVoyage, SelectedCall, ArrSelectedVesselCD, ArrSelectedVoyage, ArrSelectedCall } = this.state.BookingDetails;
        var vesselHasVoyageCalls;

        if (SelectedVesselCD != '' && SelectedVesselCD != null) {
            var selectedVessel = this.state.RefVessels.filter(x => x.VesselCd.toUpperCase() == SelectedVesselCD.toUpperCase());
            if (selectedVessel != null && selectedVessel != undefined && selectedVessel.length > 0) {
                vesselHasVoyageCalls = selectedVessel[0].VoyagesHaveCalls;
            }

            if (SelectedVesselCD != null && SelectedVesselCD != '' && ArrSelectedVesselCD != null && ArrSelectedVesselCD != '') {
                if (SelectedVesselCD != ArrSelectedVesselCD) {
                    PopupWindow.showErrorMessage('Alert', 'Departing and Arriving VVC should be same');
                    return false;
                }
            }
        }

        if (((SelectedVesselCD == '' && SelectedVoyage == '' && SelectedCall == '') || (SelectedVesselCD != '' && SelectedVoyage != '' && (!vesselHasVoyageCalls || (vesselHasVoyageCalls && SelectedCall != '')))) &&
            ((ArrSelectedVesselCD == '' && ArrSelectedVoyage == '' && ArrSelectedCall == '') || (ArrSelectedVesselCD != '' && ArrSelectedVoyage != '' && (!vesselHasVoyageCalls || (vesselHasVoyageCalls && ArrSelectedCall != ''))))) {
            
            var DepVVC = SelectedVesselCD + ',' + SelectedVoyage + ',' + SelectedCall;
            var ArrVVC = ArrSelectedVesselCD + ',' + ArrSelectedVoyage + ',' + ArrSelectedCall;

            var url = Config.ApiBaseUrl + '/api/reeferstatus/ValidateVVCEntered?DepVVC=' + DepVVC + '&ArrVVC=' + ArrVVC;
            
            var request = RCUtils.FetchRequest(url, { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            RCUtils.fetchRetry(request)
                .then(RCUtils.handleResponse)
                .then(response => response.json() as Promise<string>)
                .then(data => {
                    
                    if (data != '') {
                        if (data == 'DNE')
                            PopupWindow.showErrorMessage("Error", 'The Departing VVC, ' + SelectedVesselCD + ' ' + SelectedVoyage + ' ' + SelectedCall + ', does not exist. A VVC cannot be created here.');
                        else if (data == 'ANE')
                            PopupWindow.showErrorMessage("Error", 'The Arriving VVC, ' + ArrSelectedVesselCD + ' ' + ArrSelectedVoyage + ' ' + ArrSelectedCall + ', does not exist. A VVC cannot be created here.');
                        return false;
                    }
                    else {
                        
                        this.OnSubmitVVCValidations();
                    }
                });
        }
        else {
            
            if (SelectedVesselCD != null && SelectedVesselCD != '' && ArrSelectedVesselCD != null && ArrSelectedVesselCD != '') {
                if (SelectedVesselCD != ArrSelectedVesselCD) {
                    PopupWindow.showErrorMessage('Alert', 'Departing and Arriving VVC should be same');
                    return false;
                }
            }

            var voyagesHaveCalls;
            if (SelectedVesselCD != '' && SelectedVesselCD != null) {
                var selectedVessel = this.state.RefVessels.filter(x => x.VesselCd.toUpperCase() == SelectedVesselCD.toUpperCase());
                if (selectedVessel != null && selectedVessel != undefined && selectedVessel.length > 0) {
                    voyagesHaveCalls = selectedVessel[0].VoyagesHaveCalls;
                }
                else {
                    PopupWindow.showErrorMessage('Alert', 'Departing VVC not exists');
                    return false;
                }
            }


            if (SelectedVesselCD != '' && SelectedVoyage == '') {
                PopupWindow.showErrorMessage('Alert', 'A voyage number must be specified for the Departing VVC.');
                return false;
            }
            else if (SelectedVesselCD != '' && voyagesHaveCalls && SelectedCall == '') {
                PopupWindow.showErrorMessage('Alert', 'A call must be specified for the Departing VVC.');
                return false;
            }
            else if (ArrSelectedVesselCD != '' && ArrSelectedVoyage == '') {
                PopupWindow.showErrorMessage('Alert', 'A voyage number must be specified for the Arriving VVC.');
                return false;
            }
            else if (ArrSelectedVesselCD != '' && voyagesHaveCalls && ArrSelectedCall == '') {
                PopupWindow.showErrorMessage('Alert', 'A call must be specified for the Arriving VVC.');
                return false;
            }
        }

    }
    OnSubmitVVCValidations() {
        
        methodResult = false;
        var isfound = this.state.BookingList.filter(x => x.BookingNumber.toLowerCase() == this.state.BookingDetails.BookingNumber.toLowerCase());
        const { SelectedVesselCD, SelectedVoyage, SelectedCall, ArrSelectedVesselCD, ArrSelectedVoyage, ArrSelectedCall } = this.state.BookingDetails;
        const { DepartingVVC, ArrivingVVC, VoyageVesselCd, LifecycleCd } = isfound[0];//.SelectedReefers[0];
        var PrevDepartingVoyage = DepartingVVC.split('-')[0].trim();
        var PrevDepartingCall = DepartingVVC.split('-')[1].trim();
        var PrevArrivalVoyage = ArrivingVVC.split('-')[0].trim();
        var PrevArrivalCall = ArrivingVVC.split('-')[1].trim();

        var currentdepartingVVC = (VoyageVesselCd == null ? '' : VoyageVesselCd) + ',' + PrevDepartingVoyage + ',' + PrevDepartingCall;
        var currentarrivalVVC = (PrevArrivalVoyage != '' ? VoyageVesselCd : '') + ',' + PrevArrivalVoyage + ',' + PrevArrivalCall;
        var chosenDepartingVVC = SelectedVesselCD + ',' + SelectedVoyage + ',' + SelectedCall;
        var chosenArrivalVVC = ArrSelectedVesselCD + ',' + ArrSelectedVoyage + ',' + ArrSelectedCall;

        var submitVVCInputData: server.SubmitVVCInputData = {
            CurrentDepVVC: (LifecycleCd == 'C' || LifecycleCd == null) ? ',,' : currentdepartingVVC,// && chosenDepartingVVC == ',,'
            CurrentArrVVC: (LifecycleCd == 'C' || LifecycleCd == null) ? ',,' : currentarrivalVVC, // && chosenArrivalVVC == ',,'
            ChosenDepVVC: chosenDepartingVVC,
            ChosenArrVVC: chosenArrivalVVC,
            LifecycleCd: LifecycleCd
        }
        var inputBody = JSON.stringify(submitVVCInputData);
        var url = Config.ApiBaseUrl + '/api/reeferstatus/SubmitVVC';
        
        var request = RCUtils.FetchRequest(url, { method: 'POST', body: inputBody, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        RCUtils.fetchRetry(request)
            .then(RCUtils.handleResponse)
            .then(response => response.json() as Promise<server.SubmitVVCResult>)
            .then(data => {
                
                if (data.IsPromptMessage) {
                    $('#globalLoader').hide();
                    RCNGWindow.ConfirmWindow.showConfirmBox(data.ResultMessage, this.SaveUserInputToState.bind(this, data.PromptId), this.closeUserConfirmation.bind(this));
                }
                else if (!data.IsPromptMessage && data.ResultMessage != null && data.ResultMessage != '') {
                    PopupWindow.showErrorMessage('Error', data.ResultMessage);
                    methodResult = false;
                    return methodResult;
                }
                else {
                    this.SaveUserInputToState(data.PromptId);
                    return methodResult;
                }
            });
    }
    closeUserConfirmation() {
        methodResult = false;
        RCNGWindow.ConfirmWindow.close();
        return false;
    }
    SaveUserInputToState(userInput: number) {
        
        $('#globalLoader').show();
        var bookingSystem: server.BookingDetails = JSON.parse(JSON.stringify(this.state.BookingDetails));
        bookingSystem.userInput = userInput;

        methodResult = true;
        this.setState({ BookingDetails: bookingSystem }, () => {
            RCNGWindow.ConfirmWindow.close();//RCNG-109
            self.props.renderWizardPage(2, self.state, 1);
            //this.submitAssignBookingAfterPromptMessage();
        }); //WI-27079:RCWeb - RC UI Edit Booking Changes
    }
    ValidateBooking() {
        if (this.props.formState.IsOpen == 'New') {
            NewBookingCreate.UpdateButtonStyle(false);
        }
        if (TempBooking != self.state.BookingDetails.BookingNumber) {
            if (self.state.BookingDetails.BookingNumber != null && self.state.BookingDetails.BookingNumber != '' && self.state.isAllBooking == 0) {
                $('#globalLoader').show();
                var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/GetbookingInfoUI?BookingNumber=' + self.state.BookingDetails.BookingNumber)
                fetch(request)
                    .then(RCUtils.handleError)
                    .then(response => response.json() as Promise<server.USP_BookingConditionUI_Result[]>)
                    .then(data => {
                        $('#globalLoader').hide();
                        if (data != null && data != undefined && data.length > 0) {
                            //latest Change
                            if (this.props.formState.IsOpen == 'New') {
                                PopupWindow.showErrorMessage("Alert", "Booking " + this.state.BookingDetails.BookingNumber + " already exists.");
                                NewBookingCreate.UpdateButtonStyle(true);
                                return;
                            }
                            else {
                                this.setState({ BookingList: data }, () => { this.ValidateEditBooking() });
                            }
                            //this.setState({ BookingList: data }, () => { this.ValidateEditBooking() });  remove comment
                            //
                        }
                        //latest Change
                        else if (this.props.formState.IsOpen == 'Edit') {
                            PopupWindow.showErrorMessage("Alert", "Booking " + this.state.BookingDetails.BookingNumber + " not found.");
                            return;
                        }
                        else {
                            if (this.state.ReeferforCreate != "") {
                                var BookingReefersDetails = emptyBookingReefers;

                                BookingReefersDetails.BookingReefers = this.state.ReeferforCreate;
                                BookingReefersDetails.SelectedBookingReefers = this.state.ReeferforCreate;
                                var validationsummary = [];
                                var ReeferwithUnitID = this.state.ReeferforCreate + '-' + this.state.UnitmasterId;
                                validationsummary.push(ReeferwithUnitID);
                                BookingReefersDetails.ReeferwithUnitID = validationsummary;
                                this.setState({ BookingReefers: BookingReefersDetails }, () => { self.props.renderWizardPage(2, self.state, 1); });
                            }
                            else {
                                if (self.state.BookingReefers.SelectedBookingReefers == "" || self.state.BookingReefers.SelectedBookingReefers == null) {
                                    NewBookingCreate.UpdateButtonStyle(false);//RCNG-925
                                }
                                //NewBookingCreate.UpdateButtonStyle(true);
                                self.props.renderWizardPage(2, self.state, 1);
                            }
                        }

                    });
            }
        }
        else {
            if (self.state.BookingReefers.SelectedBookingReefers == "" || self.state.BookingReefers.SelectedBookingReefers == null) {
                NewBookingCreate.UpdateButtonStyle(false);//RCNG-925
            }
            self.props.renderWizardPage(2, self.state, 1);
        }
    }

    GetBookingData() {
        if (this.props.formState.IsOpen == 'New') {
            NewBookingCreate.UpdateButtonStyle(false);
        }
        if (this.props.formState.IsOpen == 'View') {
            ViewBooking.UpdateButtonStyle(true);
        }
        if (self.state.BookingDetails.BookingNumber == '' || self.state.BookingDetails.BookingNumber == undefined)
            PopupWindow.showErrorMessage("Alert", "Please Enter Booking Number.");
        else if (self.state.BookingDetails.BookingNumber != null && self.state.BookingDetails.BookingNumber != '' && self.state.isAllBooking == 0) {
            $('#globalLoader').show();
            var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/GetbookingDataByNumber?BookingNumber=' + self.state.BookingDetails.BookingNumber)
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json() as Promise<server.BookingDataByNumber[]>)
                .then(data => {
                    $('#globalLoader').hide();
                    if (data != null && data != undefined && data.length > 0) {
                        //latest Change
                        if (this.props.formState.IsOpen == 'New') {
                            PopupWindow.showErrorMessage("Alert", "Booking " + this.state.BookingDetails.BookingNumber + " already exists.");
                            NewBookingCreate.UpdateButtonStyle(true);
                            return;
                        }
                        else {
                            this.setState({ BookingList: data }, () => { this.EditBooking(); });
                            if (this.props.formState.IsOpen == 'View') {
                                ViewBooking.UpdateButtonStyle(false);
                            }
                        }
                        //this.setState({ BookingList: data }, () => { this.ValidateEditBooking() });  remove comment
                        //
                    }
                    //latest Change
                    else if (this.props.formState.IsOpen == 'Edit' || this.props.formState.IsOpen == 'View') {
                        PopupWindow.showErrorMessage("Alert", "Booking " + this.state.BookingDetails.BookingNumber + " not found.");
                        return;
                    }
                    //else if (this.props.formState.IsOpen == 'New') {
                    //NewBookingCreate.UpdateButtonStyle(true);
                    //return;
                    //}
                    //

                });
        }
    }

    onSuggestionsFetchRequestedforvessel = ({ value }) => {
        this.setState({
            suggestionsVesselId: this.getvesselNameSuggestions(value)
        });
    };
    getvesselNameSuggestions(value) {
        //var vessels = this.state.RefVessels;
        var VesselData = this.state.RefVessels.map(fence => fence.VesselCd);
        var vessels = uniq(VesselData);
        var inputValue = value.trim().toLowerCase();
        var inputLength = inputValue.length;
        return inputLength === 0 ? [] : vessels.filter(tag =>
            tag.toLowerCase().slice(0, inputLength) === inputValue
        );
    };
    onSuggestionsClearRequestedforvessel = () => {
        this.setState({
            suggestionsVesselId: []
        });
    };
    onChangeVesselId = (event, { newValue }) => {
        var filters = this.state.BookingDetails;
        filters.SelectedVesselCD = newValue;
        filters.SelectedVoyage = '';
        filters.SelectedCall = '';
        //$('#vesselID').addClass("fw-semibold");

        this.setState({
            BookingDetails: filters
        });
        this.setState({
            suggestionsVoyage: this.getvoyageNameSuggestions(newValue)
        });
    };
    onChangcall = (event, { newValue }) => {
        var filters = this.state.BookingDetails;
        filters.SelectedCall = newValue;
        //$('#vesselID').addClass("fw-semibold");

        this.setState({
            BookingDetails: filters
        });
    };
    renderSuggestionVesselvalue(suggestion) {
        return <span>{suggestion}</span>;
    }

    getSuggestionVesselValue(suggestion) {
        return suggestion;
    }
    onSuggestionsFetchRequestedforvoyage = ({ value }) => {
        this.setState({
            suggestionsVoyage: this.voyageNameSuggestions(value)
        });
    };
    onSuggestionsFetchRequestedforcall = ({ value }) => {
        this.setState({
            suggestionsCalls: this.callSuggestions(value)
        });
    };
    callSuggestions(value) {
        if (this.state.BookingDetails.SelectedVesselCD != "" && this.state.BookingDetails.SelectedVesselCD != null && this.state.BookingDetails.SelectedVoyage != "" && this.state.BookingDetails.SelectedVoyage != null) {
            var VesselData = this.state.RefVessels;
            var inputValue = value.trim().toLowerCase();
            var inputLength = inputValue.length;
            var test = inputLength === 0 ? [] : VesselData.filter(tag => tag.VesselCd === this.state.BookingDetails.SelectedVesselCD
                && tag.VoyageNum === this.state.BookingDetails.SelectedVoyage && tag.CallNum.toLowerCase().slice(0, inputLength) === inputValue
            );
            //return test;
            return uniq(test.map(fence => fence.CallNum));
        }
        else
            return [];
    };
    voyageNameSuggestions(value) {
        if (this.state.BookingDetails.SelectedVesselCD != "" && this.state.BookingDetails.SelectedVesselCD != null) {
            var VesselData = this.state.RefVessels;
            var inputValue = value.trim().toLowerCase();
            var inputLength = inputValue.length;
            var test = inputLength === 0 ? [] : VesselData.filter(tag => tag.VesselCd === this.state.BookingDetails.SelectedVesselCD
                && tag.VoyageNum.toLowerCase().slice(0, inputLength) === inputValue
            );
            return uniq(test.map(fence => fence.VoyageNum));
        }
        else
            return [];
    };
    getvoyageNameSuggestions(value) {
        var VesselData = this.state.RefVessels;
        var inputValue = value.trim().toLowerCase();
        var inputLength = inputValue.length;
        var test = inputLength === 0 ? [] : VesselData.filter(tag =>
            tag.VesselCd.toLowerCase().slice(0, inputLength) === inputValue
        );
        return uniq(test.map(fence => fence.VoyageNum));
    };
    getcallSuggestions(value) {
        var VesselData = this.state.RefVessels;
        var inputValue = value.trim().toLowerCase();
        var inputLength = inputValue.length;
        var test = inputLength === 0 ? [] : VesselData.filter(tag => tag.VesselCd === this.state.BookingDetails.SelectedVesselCD
            && tag.VoyageNum.toLowerCase().slice(0, inputLength) === inputValue
        );
        return uniq(test.map(fence => fence.CallNum));
    };
    onSuggestionsClearRequestedforvoyage = () => {
        this.setState({
            suggestionsVoyage: []
        });
    };
    onSuggestionsClearRequestedforcall = () => {
        this.setState({
            suggestionsCalls: []
        });
    };
    onChangevoyage = (event, { newValue }) => {
        var filters = this.state.BookingDetails;
        filters.SelectedVoyage = newValue;
        //$('#vesselID').addClass("fw-semibold");
        filters.SelectedCall = '';
        this.setState({
            BookingDetails: filters
        });
        this.setState({
            suggestionsCalls: this.getcallSuggestions(newValue)
        });
    };
    renderSuggestionvoyagevalue(suggestion) {
        return <span>{suggestion}</span>;
    }

    getSuggestionvoyageValue(suggestion) {
        return suggestion;
    }
    renderSuggestioncallvalue(suggestion) {
        return <span>{suggestion}</span>;
    }

    getSuggestioncallValue(suggestion) {
        return suggestion;
    }

    onSuggestionsFetchRequestedforArrvessel = ({ value }) => {
        this.setState({
            ArrsuggestionsVesselId: this.getArrvesselNameSuggestions(value)
        });
    };
    getArrvesselNameSuggestions(value) {
        //var vessels = this.state.RefVessels;
        var VesselData = this.state.RefVessels.map(fence => fence.VesselCd);
        var vessels = uniq(VesselData);
        var inputValue = value.trim().toLowerCase();
        var inputLength = inputValue.length;
        return inputLength === 0 ? [] : vessels.filter(tag =>
            tag.toLowerCase().slice(0, inputLength) === inputValue
        );
    };
    onSuggestionsClearRequestedforArrvessel = () => {
        this.setState({
            ArrsuggestionsVesselId: []
        });
    };
    onChangeArrVesselId = (event, { newValue }) => {
        var filters = this.state.BookingDetails;
        filters.ArrSelectedVesselCD = newValue;
        filters.ArrSelectedVoyage = '';
        filters.ArrSelectedCall = '';

        this.setState({
            BookingDetails: filters
        });
        this.setState({
            ArrsuggestionsVoyage: this.getArrvoyageNameSuggestions(newValue)
        });
    };
    onChangArrcall = (event, { newValue }) => {
        var filters = this.state.BookingDetails;
        filters.ArrSelectedCall = newValue;

        this.setState({
            BookingDetails: filters
        });
    };
    renderSuggestionArrVesselvalue(suggestion) {
        return <span>{suggestion}</span>;
    }

    getSuggestionArrVesselValue(suggestion) {
        return suggestion;
    }
    onSuggestionsFetchRequestedforArrvoyage = ({ value }) => {
        this.setState({
            ArrsuggestionsVoyage: this.ArrvoyageNameSuggestions(value)
        });
    };
    onSuggestionsFetchRequestedforArrcall = ({ value }) => {
        this.setState({
            ArrsuggestionsCalls: this.ArrcallSuggestions(value)
        });
    };
    ArrcallSuggestions(value) {
        if (this.state.BookingDetails.ArrSelectedVesselCD != "" && this.state.BookingDetails.ArrSelectedVesselCD != null && this.state.BookingDetails.ArrSelectedVoyage != "" && this.state.BookingDetails.ArrSelectedVoyage != null) {
            var VesselData = this.state.RefVessels;
            var inputValue = value.trim().toLowerCase();
            var inputLength = inputValue.length;
            var test = inputLength === 0 ? [] : VesselData.filter(tag => tag.VesselCd === this.state.BookingDetails.ArrSelectedVesselCD
                && tag.VoyageNum === this.state.BookingDetails.ArrSelectedVoyage && tag.CallNum.toLowerCase().slice(0, inputLength) === inputValue
            );
            //return test;
            return uniq(test.map(fence => fence.CallNum));
        }
        else
            return [];
    };
    ArrvoyageNameSuggestions(value) {
        if (this.state.BookingDetails.ArrSelectedVesselCD != "" && this.state.BookingDetails.ArrSelectedVesselCD != null) {
            var VesselData = this.state.RefVessels;
            var inputValue = value.trim().toLowerCase();
            var inputLength = inputValue.length;
            var test = inputLength === 0 ? [] : VesselData.filter(tag => tag.VesselCd === this.state.BookingDetails.ArrSelectedVesselCD
                && tag.VoyageNum.toLowerCase().slice(0, inputLength) === inputValue
            );
            return uniq(test.map(fence => fence.VoyageNum));
        }
        else
            return [];
    };
    getArrvoyageNameSuggestions(value) {
        var VesselData = this.state.RefVessels;
        var inputValue = value.trim().toLowerCase();
        var inputLength = inputValue.length;
        var test = inputLength === 0 ? [] : VesselData.filter(tag =>
            tag.VesselCd.toLowerCase().slice(0, inputLength) === inputValue
        );
        return uniq(test.map(fence => fence.VoyageNum));
    };
    getArrcallSuggestions(value) {
        var VesselData = this.state.RefVessels;
        var inputValue = value.trim().toLowerCase();
        var inputLength = inputValue.length;
        var test = inputLength === 0 ? [] : VesselData.filter(tag => tag.VesselCd === this.state.BookingDetails.ArrSelectedVesselCD
            && tag.VoyageNum.toLowerCase().slice(0, inputLength) === inputValue
        );
        return uniq(test.map(fence => fence.CallNum));
    };
    onSuggestionsClearRequestedforArrvoyage = () => {
        this.setState({
            ArrsuggestionsVoyage: []
        });
    };
    onSuggestionsClearRequestedforArrcall = () => {
        this.setState({
            ArrsuggestionsCalls: []
        });
    };
    onChangeArrvoyage = (event, { newValue }) => {
        var filters = this.state.BookingDetails;
        filters.ArrSelectedVoyage = newValue;
        //$('#vesselID').addClass("fw-semibold");
        filters.ArrSelectedCall = '';
        this.setState({
            BookingDetails: filters
        });
        this.setState({
            ArrsuggestionsCalls: this.getArrcallSuggestions(newValue)
        });
    };
    renderSuggestionArrvoyagevalue(suggestion) {
        return <span>{suggestion}</span>;
    }

    getSuggestionArrvoyageValue(suggestion) {
        return suggestion;
    }
    renderSuggestionArrcallvalue(suggestion) {
        return <span>{suggestion}</span>;
    }

    getSuggestionArrcallValue(suggestion) {
        return suggestion;
    }
    renderBookingData() {
        $('#globalLoader').show();
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/GetbookingInfoUI?BookingNumber=' + self.state.BookingDetails.BookingNumber)
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.USP_BookingCurrentConditionUI_Result>)
            .then(data => {
                $('#globalLoader').hide();
                if (data != null && data != undefined) {
                    var BookingInfoDetails = emptyBookingDetails;
                    BookingInfoDetails.Shipper = data.Shipper;
                    BookingInfoDetails.Consignee = data.Consignee;
                    BookingInfoDetails.ShipperCode = data.ShipperCode;
                    BookingInfoDetails.POR = data.POR;
                    BookingInfoDetails.POL = data.POL;
                    BookingInfoDetails.POD = data.POD;
                    BookingInfoDetails.VesselETD = data.VesselETD != null ? DateFormat(new Date(data.VesselETD), 'mm/dd/yyyy HH:MM:ss') : null;
                    BookingInfoDetails.VesselETA = data.VesselETA != null ? DateFormat(new Date(data.VesselETA), 'mm/dd/yyyy HH:MM:ss') : null;
                    BookingInfoDetails.BLNumber = data.BLNumber;
                    BookingInfoDetails.ContractParty = data.ContractParty;
                    BookingInfoDetails.Consolidation = data.Consolidation;
                    BookingInfoDetails.Agent = data.Agent;
                    BookingInfoDetails.VesselCode = data.VesselCode;
                    BookingInfoDetails.VoyageNumber = data.VoyageNumber;
                    BookingInfoDetails.Call = data.Shipper;
                    BookingInfoDetails.Forwarder = data.Forwarder;
                    BookingInfoDetails.Notify = data.Notify;
                    BookingInfoDetails.BookingNumber = data.BookingNumber;
                    BookingInfoDetails.DEL = data.DEL;
                    BookingInfoDetails.BKCustomer = data.BKCustomer;
                    this.setState({ BookingDetails: BookingInfoDetails });
                }

            });
    }
    CopyBookingNumberChange(event: React.FormEvent<HTMLInputElement>) {
        var Value: string = event.currentTarget.value;
        this.setState({
            CopyBookingNumber: Value
        });
    }

    BookingNumberChange(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.BookingDetails;
        var Value: string = event.currentTarget.value;
        filters.BookingNumber = Value;
        this.setState({
            BookingDetails: filters, isAllBooking: 0
        });
        if (this.props.formState.IsOpen == 'Edit') {
            var BookingInfoDetails = emptyBookingDetails;
            BookingInfoDetails.Shipper = '';
            BookingInfoDetails.Consignee = '';
            BookingInfoDetails.ShipperCode = '';
            BookingInfoDetails.POR = '';
            BookingInfoDetails.POL = '';
            BookingInfoDetails.POD = '';
            BookingInfoDetails.VesselETD = null;//DateFormat(new Date(), 'mm/dd/yyyy HH:MM');
            BookingInfoDetails.VesselETA = null;//DateFormat(new Date(), 'mm/dd/yyyy HH:MM');
            BookingInfoDetails.BLNumber = '';
            BookingInfoDetails.ContractParty = '';
            BookingInfoDetails.Consolidation = '';
            BookingInfoDetails.Agent = '';
            BookingInfoDetails.VesselCode = '';
            BookingInfoDetails.VoyageNumber = '';
            BookingInfoDetails.Call = '';
            BookingInfoDetails.Forwarder = '';
            BookingInfoDetails.Notify = '';
            BookingInfoDetails.DEL = '';
            BookingInfoDetails.IsVVCModified = false;
            BookingInfoDetails.SelectedVesselCD = '';
            BookingInfoDetails.SelectedCall = '';
            BookingInfoDetails.SelectedVoyage = '';
            BookingInfoDetails.ArrSelectedVesselCD = '';
            BookingInfoDetails.ArrSelectedCall = '';
            BookingInfoDetails.ArrSelectedVoyage = '';
            BookingInfoDetails.userInput = 0;
            BookingInfoDetails.BKCustomer = '';
            var BookingReefers = emptyBookingReefers;
            BookingReefers.BookingReefers = '';
            BookingReefers.SelectedBookingReefers = '';
            BookingReefers.ReeferwithUnitID = [];
            this.setState({ BookingDetails: BookingInfoDetails, BookingReefers: BookingReefers });
            NewBookingEdit.UpdateButtonStyle(true);
        }
        //else if (this.props.formState.isViewOnly)
        //    ViewBooking.UpdateButtonStyle(false);
        //else if (self.state.CopyBookingNumber != "")  {
        //else if (self.state.CopyBookingNumber != "" ||(self.state.ReeferwithUnitID!=undefined && self.state.ReeferwithUnitID.length==0)){
        //    NewBookingCreate.UpdateButtonStyle(false);
        //}
        //else {
        //    var BookingReefers = emptyBookingReefers;
        //    BookingReefers.BookingReefers = '';
        //    BookingReefers.SelectedBookingReefers = '';
        //    BookingReefers.ReeferwithUnitID = [];
        //    this.setState({ BookingReefers: BookingReefers });
        //    NewBookingCreate.UpdateButtonStyle(false);
        //}
        else
            NewBookingCreate.UpdateButtonStyle(false);
    }
    onChangeBookingNumber = (event, { newValue }) => {
        var filters = this.state.BookingDetails;
        filters.BookingNumber = newValue;

        this.setState({
            BookingDetails: filters
        });
        var isfound = this.state.BookingList.filter(x => x.BookingNumber.toLowerCase() == newValue.toLowerCase());
        if (this.state.isBookingEdit) {
            if (isfound.length > 0) {
                var BookingInfoDetails = emptyBookingDetails;
                BookingInfoDetails.Shipper = isfound[0].Shipper;
                BookingInfoDetails.Consignee = isfound[0].Consignee;
                BookingInfoDetails.ShipperCode = isfound[0].ShipperCode;
                BookingInfoDetails.POR = isfound[0].POR;
                BookingInfoDetails.POL = isfound[0].POL;
                BookingInfoDetails.POD = isfound[0].POD;
                BookingInfoDetails.VesselETD = isfound[0].VesselETD != null ? DateFormat(new Date(isfound[0].VesselETD), 'mm/dd/yyyy HH:MM:ss') : null;
                BookingInfoDetails.VesselETA = isfound[0].VesselETA != null ? DateFormat(new Date(isfound[0].VesselETA), 'mm/dd/yyyy HH:MM:ss') : null;
                BookingInfoDetails.BLNumber = isfound[0].BLNumber;
                BookingInfoDetails.ContractParty = isfound[0].ContractParty;
                BookingInfoDetails.Consolidation = isfound[0].Consolidation;
                BookingInfoDetails.Agent = isfound[0].Agent;
                BookingInfoDetails.VesselCode = isfound[0].VesselCode;
                BookingInfoDetails.VoyageNumber = isfound[0].VoyageNumber;
                BookingInfoDetails.Call = isfound[0].Call;
                BookingInfoDetails.Forwarder = isfound[0].Forwarder;
                BookingInfoDetails.Notify = isfound[0].Notify;
                BookingInfoDetails.BookingNumber = isfound[0].BookingNumber;
                BookingInfoDetails.DEL = isfound[0].DEL;
                BookingInfoDetails.BKCustomer = isfound[0].BKCustomer;
                this.setState({ BookingDetails: BookingInfoDetails });
            }
            else {
                var BookingInfoDetails = emptyBookingDetails;
                BookingInfoDetails.Shipper = '';
                BookingInfoDetails.Consignee = '';
                BookingInfoDetails.ShipperCode = '';
                BookingInfoDetails.POR = '';
                BookingInfoDetails.POL = '';
                BookingInfoDetails.POD = '';
                BookingInfoDetails.VesselETD = null;// DateFormat(new Date(), 'mm/dd/yyyy HH:MM');
                BookingInfoDetails.VesselETA = null;// DateFormat(new Date(), 'mm/dd/yyyy HH:MM');
                BookingInfoDetails.BLNumber = '';
                BookingInfoDetails.ContractParty = '';
                BookingInfoDetails.Consolidation = '';
                BookingInfoDetails.Agent = '';
                BookingInfoDetails.VesselCode = '';
                BookingInfoDetails.VoyageNumber = '';
                BookingInfoDetails.Call = '';
                BookingInfoDetails.Forwarder = '';
                BookingInfoDetails.Notify = '';
                BookingInfoDetails.DEL = '';
                BookingInfoDetails.BKCustomer = '';
                this.setState({ BookingDetails: BookingInfoDetails });
            }
        }
        else {
            if (isfound.length > 0) {
                this.ValidateEditBooking();
            }
        }

    };
    ValidateEditBooking() {
        //Latest Code
        //if (!this.state.isBookingEdit) {
        //    var confirmationMessage = "Booking " + this.state.BookingDetails.BookingNumber + " already exists. Edit this booking?";
        //    RCNGWindow.ConfirmWindow.showConfirmBox(confirmationMessage, this.EditBookingAction.bind(this), this.closeConfirmation.bind(this));
        //}
        //else {
        //    this.EditBooking();
        //}
        //
        if (this.state.isBookingEdit) {
            this.EditBooking();
        }
    }
    EditBooking() {
        
        var isfound = this.state.BookingList.filter(x => x.BookingNumber.toLowerCase() == this.state.BookingDetails.BookingNumber.toLowerCase());
        var BookingInfoDetails = emptyBookingDetails;
        BookingInfoDetails.Shipper = isfound[0].Shipper;
        BookingInfoDetails.Consignee = isfound[0].Consignee;
        BookingInfoDetails.ShipperCode = isfound[0].ShipperCode;
        BookingInfoDetails.POR = isfound[0].POR;
        BookingInfoDetails.POL = isfound[0].POL;
        BookingInfoDetails.POD = isfound[0].POD;
        BookingInfoDetails.VesselETD = isfound[0].VesselETD != null ? DateFormat(new Date(isfound[0].VesselETD), 'mm/dd/yyyy HH:MM:ss') : null;
        BookingInfoDetails.VesselETA = isfound[0].VesselETA != null ? DateFormat(new Date(isfound[0].VesselETA), 'mm/dd/yyyy HH:MM:ss') : null;
        BookingInfoDetails.BLNumber = isfound[0].BLNumber;
        BookingInfoDetails.ContractParty = isfound[0].ContractParty;
        BookingInfoDetails.Consolidation = isfound[0].Consolidation;
        BookingInfoDetails.Agent = isfound[0].Agent;
        BookingInfoDetails.VesselCode = isfound[0].VesselCode;
        BookingInfoDetails.VoyageNumber = isfound[0].VoyageNumber;
        BookingInfoDetails.Call = isfound[0].Call;
        BookingInfoDetails.Forwarder = isfound[0].Forwarder;
        BookingInfoDetails.Notify = isfound[0].Notify;
        BookingInfoDetails.BookingNumber = isfound[0].BookingNumber;
        BookingInfoDetails.DEL = isfound[0].DEL;
        BookingInfoDetails.BKCustomer = isfound[0].BKCustomer;
        if (isfound[0].LifecycleCd == 'L' || isfound[0].LifecycleCd == 'R' || isfound[0].LifecycleCd == 'D' || isfound[0].LifecycleCd == 'P') {
            var departingVVC = isfound[0].DepartingVVC.split('-');
            var depVoyage = departingVVC[0].trim().length > 0 ? departingVVC[0].trim() : '';
            var depCall = departingVVC[1].trim().length > 0 ? departingVVC[1].trim() : '';
            var arrivingVVC = isfound[0].ArrivingVVC.split('-');
            var arrVoyage = arrivingVVC[0].trim().length > 0 ? arrivingVVC[0].trim() : '';
            var arrCall = arrivingVVC[1].trim().length > 0 ? arrivingVVC[1].trim() : '';

            BookingInfoDetails.SelectedVoyage = depVoyage;
            BookingInfoDetails.SelectedCall = depCall;
            BookingInfoDetails.SelectedVesselCD = depVoyage != '' ? isfound[0].VoyageVesselCd : '';
            BookingInfoDetails.ArrSelectedVesselCD = arrVoyage != '' ? isfound[0].VoyageVesselCd : '';
            BookingInfoDetails.ArrSelectedVoyage = arrVoyage;
            BookingInfoDetails.ArrSelectedCall = arrCall;
        }
        var BookingReefersData = emptyBookingReefers;
        BookingReefersData.BookingReefers = this.state.BookingList.map(x => x.ReeferID).toString();
        BookingReefersData.SelectedBookingReefers = this.state.BookingList.map(x => x.ReeferID).toString();
        BookingReefersData.ReeferwithUnitID = this.state.BookingList.map(x => x.ReeferwithUnitID);
        var gridData = [];
        forEach(this.state.BookingList, function (bookingItem) {
            
            if (bookingItem != "" && bookingItem != null) {

                var item = {
                    action: '', reeferId: bookingItem.ReeferID, cargoCare: bookingItem.CCProfileName, accessCodes: bookingItem.CustomerAccessGroupID, bookedTemperature: bookingItem.BookedTemperature,
                    bookedTemperatureQualifier: bookingItem.BookedTemperatureQualifier, bookedTemperatureMin: bookingItem.BookedTemperatureMin, bookedTemperatureMax: bookingItem.BookedTemperatureMax,
                    humidity: bookingItem.HumiditySetpoint, commodity: bookingItem.Commodity, STCC: bookingItem.STCC, HS: bookingItem.HSCode, gensetId: bookingItem.GensetId, ventSetting: bookingItem.VentSetting,
                    HVFlag: bookingItem.HighValueFlag, serviceLevel: bookingItem.ServiceLevel, CAFlag: bookingItem.CAFlag, O2Setpoint: bookingItem.O2Setpoint, O2SetpointMin: bookingItem.O2SetpointMin, O2SetpointMax: bookingItem.O2SetpointMax,
                    CO2Setpoint: bookingItem.CO2Setpoint, CO2SetpointMin: bookingItem.CO2SetpointMin, CO2SetpointMax: bookingItem.CO2SetpointMax, CTFlag: bookingItem.CTFlag,
                    CTDays: bookingItem.CTDays, USDAMaxTemperature: bookingItem.USDAMaxTemperature, postCTTemperature: bookingItem.PostCTTemperature, postCTTemperatureDeviation: bookingItem.PostCTTemperatureDeviation, postCTVentSetting: bookingItem.PostCTVentSetting,
                    UnitMasterId: bookingItem.UnitMasterID, CustomerAccessGroupIdsStr: '', CAGName: bookingItem.CAGName
                };
                gridData.push(item);
            }
        });
        this.setState({ BookingDetails: BookingInfoDetails, BookingReefers: BookingReefersData, rowData: gridData, isBookingEdit: true, isAllBooking: 1 }, () => { this.EditPopupMessage() });

    }
    EditBookingAction() {
        var isfound = this.state.BookingList.filter(x => x.BookingNumber.toLowerCase() == this.state.BookingDetails.BookingNumber.toLowerCase());
        var BookingInfoDetails = emptyBookingDetails;
        BookingInfoDetails.Shipper = isfound[0].Shipper;
        BookingInfoDetails.Consignee = isfound[0].Consignee;
        BookingInfoDetails.ShipperCode = isfound[0].ShipperCode;
        BookingInfoDetails.POR = isfound[0].POR;
        BookingInfoDetails.POL = isfound[0].POL;
        BookingInfoDetails.POD = isfound[0].POD;
        BookingInfoDetails.VesselETD = isfound[0].VesselETD != null ? DateFormat(new Date(isfound[0].VesselETD), 'mm/dd/yyyy HH:MM:ss') : null;
        BookingInfoDetails.VesselETA = isfound[0].VesselETA != null ? DateFormat(new Date(isfound[0].VesselETA), 'mm/dd/yyyy HH:MM:ss') : null;
        BookingInfoDetails.BLNumber = isfound[0].BLNumber;
        BookingInfoDetails.ContractParty = isfound[0].ContractParty;
        BookingInfoDetails.Consolidation = isfound[0].Consolidation;
        BookingInfoDetails.Agent = isfound[0].Agent;
        BookingInfoDetails.VesselCode = isfound[0].VesselCode;
        BookingInfoDetails.VoyageNumber = isfound[0].VoyageNumber;
        BookingInfoDetails.Call = isfound[0].Call;
        BookingInfoDetails.Forwarder = isfound[0].Forwarder;
        BookingInfoDetails.Notify = isfound[0].Notify;
        BookingInfoDetails.BookingNumber = isfound[0].BookingNumber;
        BookingInfoDetails.DEL = isfound[0].DEL;
        BookingInfoDetails.BKCustomer = isfound[0].BKCustomer;

        var ReeferInfoDetails = emptyBookingReefers;
        ReeferInfoDetails.BookingReefers = "";
        ReeferInfoDetails.SelectedBookingReefers = "";
        ReeferInfoDetails.ReeferwithUnitID = [];

        this.setState({ BookingDetails: BookingInfoDetails, isBookingEdit: true, isAllBooking: 1, BookingReefers: ReeferInfoDetails }, () => { this.EditPopupMessage() });

    }
    EditPopupMessage() {
        if (this.state.isBookingEdit) {

            if (this.props.formState.IsOpen == 'New') {
                NewBookingCreate.UpdateBookingType('Edit Booking');
                this.setState({
                    BookingDesc: 'Update the booking data. This data applies to all of the booking’s reefers.'
                });
                RCNGWindow.ConfirmWindow.close();
            }
            if (this.props.formState.IsOpen == 'Edit') {
                NewBookingEdit.UpdateButtonStyle(false);
            }
            //NewBookingEdit.UpdateBookingType('Edit Booking');
        }
        else {
            this.setState({
                BookingDesc: 'Enter the booking data. This data applies to all of the booking’s reefers.'
            });
            RCNGWindow.ConfirmWindow.close();
        }


    }
    closeConfirmation() {
        this.setState({ isBookingEdit: false });
        RCNGWindow.ConfirmWindow.close();
    }
    ShipperChange(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.BookingDetails;
        var Value: string = event.currentTarget.value;
        filters.Shipper = Value;
        this.setState({
            BookingDetails: filters
        });
    }
    ShipperCodeChange(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.BookingDetails;
        var Value: string = event.currentTarget.value;
        filters.ShipperCode = Value;
        this.setState({
            BookingDetails: filters
        });
    }
    ConsigneeChange(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.BookingDetails;
        var Value: string = event.currentTarget.value;
        filters.Consignee = Value;
        this.setState({
            BookingDetails: filters
        });
    }
    PORChange(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.BookingDetails;
        var Value: string = event.currentTarget.value;
        filters.POR = Value;
        this.setState({
            BookingDetails: filters
        });
    }
    POLChange(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.BookingDetails;
        var Value: string = event.currentTarget.value;
        filters.POL = Value;
        this.setState({
            BookingDetails: filters
        });
    }
    PODChange(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.BookingDetails;
        var Value: string = event.currentTarget.value;
        filters.POD = Value;
        this.setState({
            BookingDetails: filters
        });
    }
    DELChange(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.BookingDetails;
        var Value: string = event.currentTarget.value;
        filters.DEL = Value;
        this.setState({
            BookingDetails: filters
        });
    }
    BLNumberChange(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.BookingDetails;
        var Value: string = event.currentTarget.value;
        filters.BLNumber = Value;
        this.setState({
            BookingDetails: filters
        });
    }
    BLCustomerChange(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.BookingDetails;
        var Value: string = event.currentTarget.value;
        filters.BKCustomer = Value;
        this.setState({
            BookingDetails: filters
        });
    }
    ContractPartyChange(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.BookingDetails;
        var Value: string = event.currentTarget.value;
        filters.ContractParty = Value;
        this.setState({
            BookingDetails: filters
        });
    }
    AgentChange(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.BookingDetails;
        var Value: string = event.currentTarget.value;
        filters.Agent = Value;
        this.setState({
            BookingDetails: filters
        });
    }
    ConsolidationChange(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.BookingDetails;
        var Value: string = event.currentTarget.value;
        filters.Consolidation = Value;
        this.setState({
            BookingDetails: filters
        });
    }
    VesselCodeChange(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.BookingDetails;
        var Value: string = event.currentTarget.value;
        filters.VesselCode = Value;
        this.setState({
            BookingDetails: filters
        });
    }
    VoyageNumberChange(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.BookingDetails;
        var Value: string = event.currentTarget.value;
        filters.VoyageNumber = Value;
        this.setState({
            BookingDetails: filters
        });
    }
    CallChange(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.BookingDetails;
        var Value: string = event.currentTarget.value;
        filters.Call = Value;
        this.setState({
            BookingDetails: filters
        });
    }
    ForwarderChange(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.BookingDetails;
        var Value: string = event.currentTarget.value;
        filters.Forwarder = Value;
        this.setState({
            BookingDetails: filters
        });
    }
    NotifyChange(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.BookingDetails;
        var Value: string = event.currentTarget.value;
        filters.Notify = Value;
        this.setState({
            BookingDetails: filters
        });
    }

    ETDDateChange(date) {
        var filters = this.state.BookingDetails;
        filters.VesselETD = DateFormat(new Date(date.toString()), 'mm/dd/yyyy HH:MM:ss');
        self.setState({
            BookingDetails: filters
            //VesselETD: DateFormat(new Date(date.toString()), 'mm/dd/yyyy HH:MM:ss')
        });
        //self.setState({ VesselETD: date });
    }
    ETADateChange(date) {
        var filters = this.state.BookingDetails;
        filters.VesselETA = DateFormat(new Date(date.toString()), 'mm/dd/yyyy HH:MM:ss');
        self.setState({
            BookingDetails: filters
            //VesselETA: DateFormat(new Date(date.toString()), 'mm/dd/yyyy HH:MM:ss')
        });
        //self.setState({ VesselETA: date });
    }
    HasNonPrintableASCII(Value) {
        const IsMatch = /[^ -~]+/;
        if (IsMatch.test(Value))
            return true;
        else
            return false;
    }
    OnSearch() {
        if (self.state.BookingDetails.BookingNumber == '' || self.state.BookingDetails.BookingNumber == undefined)
            PopupWindow.showErrorMessage("Alert", "Please Enter Booking Number.");
        else {
            this.renderBookingData();
        }
    }
    //onSuggestionsFetchRequested = ({ value }) => {
    //    this.setState({
    //        suggestionsBookingNumber: this.getFenceNameSuggestions(value)
    //    });
    //};
    //getFenceNameSuggestions(value) {
    //    //var bookings = this.state.suggestionsBookingNumber;
    //    var inputValue = value.trim().toLowerCase();
    //    var inputLength = inputValue.length;
    //    return inputLength === 0 ? [] : this.state.BookingList.filter(tag =>
    //        tag.BookingNumber.toLowerCase().slice(0, inputLength) === inputValue
    //    ).map(Item => Item.BookingNumber);
    //};
    //onSuggestionsClearRequested = () => {
    //    this.setState({
    //        suggestionsBookingNumber: []
    //    });
    //};
    //renderSuggestion(suggestion) {
    //    return <span>{suggestion}</span>;
    //}

    //getSuggestionValue(suggestion) {
    //    return suggestion;
    //}
    public render() {
        //const { suggestionsBookingNumber } = this.state;
        //const FenceIdListinputProps = {
        //    id: 'Booking Number',
        //    placeholder: 'Booking Number',
        //    value: this.state.BookingDetails.BookingNumber,
        //    onChange: this.onChangeBookingNumber.bind(this)
        //};
        var CSSdisabled: any;
        if (!this.state.isBookingEdit && this.state.isViewOnly == false) {
            CSSdisabled = false;
        }
        else if (this.state.isBookingEdit && this.state.isAllBooking == 1 && this.state.isViewOnly == false) {
            CSSdisabled = false;
        }
        else if ((this.state.formname == "ReeferStatus" || this.state.formname == "ReeferStatusGrid" || this.state.formname == "SSRMReeferStatusGrid") && this.state.isViewOnly == false) {
            CSSdisabled = false;
        }
        else if ((this.state.formname == "ReeferStatus" || this.state.formname == "ReeferStatusGrid" || this.state.formname == "SSRMReeferStatusGrid") && this.state.isViewOnly == true) {
            CSSdisabled = true;
        }
        else {
            CSSdisabled = true;
        }
        var Voyagedisabled: any;
        var Calldisabled: any;
        
        if (this.state.BookingDetails.SelectedVesselCD != "" && this.state.BookingDetails.SelectedVesselCD != null) {
            Voyagedisabled = false;
            Calldisabled = true;
        }
        else {
            Voyagedisabled = true;
            Calldisabled = true;
        }
        if (this.state.BookingDetails.SelectedVoyage != "" && this.state.BookingDetails.SelectedVoyage != null) {
            //RCNG-140
            var selectedVessel = this.state.RefVessels.filter(x => x.VesselCd.toUpperCase() == this.state.BookingDetails.SelectedVesselCD.toUpperCase());
            if (selectedVessel != null && selectedVessel != undefined && selectedVessel.length > 0) {
                var vesselHasVoyageCalls = selectedVessel[0].VoyagesHaveCalls;
                if (vesselHasVoyageCalls)
                    Calldisabled = false;
                else
                    Calldisabled = true;
            }
        }
        else {
            Calldisabled = true;
        }
        var ArrVoyagedisabled: any;
        var ArrCalldisabled: any;
        if (this.state.BookingDetails.ArrSelectedVesselCD != "" && this.state.BookingDetails.ArrSelectedVesselCD != null) {
            ArrVoyagedisabled = false;
            ArrCalldisabled = true;
        }
        else {
            ArrVoyagedisabled = true;
            ArrCalldisabled = true;
        }
        if (this.state.BookingDetails.ArrSelectedVoyage != "" && this.state.BookingDetails.ArrSelectedVoyage != null) {
            //RCNG-140
            var selectedVessel = this.state.RefVessels.filter(x => x.VesselCd.toUpperCase() == this.state.BookingDetails.ArrSelectedVesselCD.toUpperCase());
            if (selectedVessel != null && selectedVessel != undefined && selectedVessel.length > 0) {
                var vesselHasVoyageCalls = selectedVessel[0].VoyagesHaveCalls;
                if (vesselHasVoyageCalls)
                    ArrCalldisabled = false;
                else
                    ArrCalldisabled = true;
            }
        }
        else {
            ArrCalldisabled = true;
        }
        const { suggestionsVesselId, suggestionsVoyage, suggestionsCalls, ArrsuggestionsVesselId, ArrsuggestionsVoyage, ArrsuggestionsCalls } = this.state;

        const FenceIdListinputPropsforvessel = {
            id: 'vesselID',
            placeholder: 'Vessel',
            value: this.state.BookingDetails.SelectedVesselCD,
            onChange: this.onChangeVesselId.bind(this),
            //readOnly: true //RCNG 94 //RCNG-109
        };
        const FenceIdListinputPropsforvoyage = {
            id: 'voyageNum',
            placeholder: 'Voyage',
            value: this.state.BookingDetails.SelectedVoyage,
            onChange: this.onChangevoyage.bind(this),
            disabled: Voyagedisabled,
        };
        const FenceIdListinputPropsforcall = {
            id: 'CallNum',
            placeholder: 'Call',
            value: this.state.BookingDetails.SelectedCall,
            onChange: this.onChangcall.bind(this),
            disabled: Calldisabled,
        };
        const FenceIdListinputPropsforArrvessel = {
            id: 'vesselID',
            placeholder: 'Vessel',
            value: this.state.BookingDetails.ArrSelectedVesselCD,
            onChange: this.onChangeArrVesselId.bind(this),
        };
        const FenceIdListinputPropsforArrvoyage = {
            id: 'voyageNum',
            placeholder: 'Voyage',
            value: this.state.BookingDetails.ArrSelectedVoyage,
            onChange: this.onChangeArrvoyage.bind(this),
            disabled: ArrVoyagedisabled,
        };
        const FenceIdListinputPropsforArrcall = {
            id: 'CallNum',
            placeholder: 'Call',
            value: this.state.BookingDetails.ArrSelectedCall,
            onChange: this.onChangArrcall.bind(this),
            disabled: ArrCalldisabled,
        };
        return <div>


            <div className="row mt-4">
                <div className="col-md-12 text-center">
                    <span className='fw-semibold'>{this.state.BookingDesc}</span>
                </div>

            </div>


            <div className="row ">

                <div className="col-md-12 px-0">

                    <hr className="HorizentalLine mt-2" />
                </div>


            </div>

            <div className={this.state.isViewOnly == false ? '' : ''}>

                <div className="row mt-2">

                    <div className="col-md-2 px-0 text-md-end">
                        <label className='col-form-label'>Booking Number :</label>
                    </div>
                    {/*<div className="col-md-2">*/}
                    {/*    <input type='text' id='txtBookingNumber' maxLength={15} value={this.state.BookingDetails.BookingNumber} onBlur={e=>this.ValidateBooking() } onChange={e => this.BookingNumberChange(e)} className='form-control' />*/}
                    {/*</div>*/}
                    {/*<div className='col-md-2'>*/}
                    {/*    <div className='input-group'>*/}
                    {/*        <Autosuggest name="geofenceID" id="geofenceID"*/}
                    {/*            suggestions={suggestionsBookingNumber}*/}
                    {/*            onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}*/}
                    {/*            onSuggestionsClearRequested={this.onSuggestionsClearRequested}*/}
                    {/*            getSuggestionValue={this.getSuggestionValue}*/}
                    {/*            renderSuggestion={this.renderSuggestion}*/}
                    {/*            inputProps={FenceIdListinputProps}*/}
                    {/*            highlightFirstSuggestion={true}*/}
                    {/*        />*/}
                    {/*    </div>*/}
                    {/*</div>*/}

                    {
                        (this.state.isBookingEdit == false && this.state.isViewOnly == false) ?
                            <div className="col-md-6">
                                <input type='text' id='BookingNumber' maxLength={35} value={this.state.BookingDetails.BookingNumber} onChange={e => this.BookingNumberChange(e)} className='form-control' />
                            </div>

                            :
                            this.state.formname == "ReeferStatus" || this.state.formname == "ReeferStatusGrid" || this.state.formname == "SSRMReeferStatusGrid" ?
                                <div className="col-md-6">
                                    <input type='text' id='BookingNumberEdit' maxLength={35} value={this.state.BookingDetails.BookingNumber} readOnly className='form-control' />
                                </div>

                                :
                                <div className="col-md-6" id="BookingSearch">

                                    <div className="input-group">
                                        <i className="far fa-search BookingNumberSearch" title="Find booking"></i>
                                        <input type='text' id='txtBookingNumber' maxLength={35} value={this.state.BookingDetails.BookingNumber} onChange={e => this.BookingNumberChange(e)} className='form-control' />

                                        <button className="btn btn-primary" type="button" id="button_login" data-bs-toggle="modal" data-bs-target="#resetPasswordModel" onClick={e => this.GetBookingData()}>Search</button>

                                    </div>
                                </div>


                    }
                    {
                        (this.state.isBookingEdit == false && this.state.isViewOnly == false) ?
                            <div className='col-md-4'>

                                <div className="row copy-booking">
                                    <div className="col-md-5 px-0 text-md-end">
                                        <span className='col-form-label'>Copy From Existing Booking :</span>
                                    </div>

                                    <div className="col-md-7">
                                        <div className="input-group">
                                            <input type='text' id='BookingNumber' maxLength={35} value={this.state.CopyBookingNumber} onChange={e => this.CopyBookingNumberChange(e)} className='form-control' />
                                            <button type='button' className='btn btn btn-primary' onClick={e => this.CopyBookingData()}>Copy</button>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            :
                            ""

                    }
                </div>




                <div className="row mt-3">

                    <div className="col-md-12 px-0">

                        <hr className="HorizentalLine hide" />
                    </div>


                </div>


                <div>


                    <div className="row mt-6">
                        <div className="col-md-2 pe-0 text-md-end">
                            <label className='col-form-label'>Shipper :</label>
                        </div>
                        <div className="col-md-6">
                            <input type='text' id='txtShipper' maxLength={100} disabled={CSSdisabled} value={this.state.BookingDetails.Shipper} onChange={e => this.ShipperChange(e)} className='form-control' title={this.state.BookingDetails.Shipper} />
                        </div>
                        <div className="col-md-1 px-0 text-md-end">
                            <label className='col-form-label'>Vessel-Voyage :</label>
                        </div>
                        <div className="col-md-3 width22">
                            <div className="input-group">
                                <input type='text' id='txtVesselCode' maxLength={10} value={this.state.BookingDetails.VesselCode} disabled={CSSdisabled} onChange={e => this.VesselCodeChange(e)} className='form-control' />
                                <input type='text' id='txtVoyageNumber' maxLength={10} value={this.state.BookingDetails.VoyageNumber} disabled={CSSdisabled} onChange={e => this.VoyageNumberChange(e)} className='form-control' />
                            </div>
                        </div>

                    </div>

                    <div className="row mt-6">

                        <div className="col-md-2 pe-0 text-md-end">
                            <label className='col-form-label'>Shipper Code :</label>
                        </div>
                        <div className="col-md-6">
                            <input type='text' id='txtShipperCode' maxLength={30} disabled={CSSdisabled} value={this.state.BookingDetails.ShipperCode} onChange={e => this.ShipperCodeChange(e)} className='form-control' />
                        </div>

                        <div className="col-md-1 pe-0 text-md-end">
                            <label className='col-form-label'>ETD :</label>
                        </div>
                        <div className="col-md-3 width22">
                            <DatePicker
                                selected={this.state.BookingDetails.VesselETD == null ? null : new Date(this.state.BookingDetails.VesselETD)}
		                        onChange={this.ETDDateChange.bind(this)}
		                        timeInputLabel="Time:"
                                showYearDropdown
                                yearDropdownItemNumber={5}
		                        dateFormat="MM/dd/yyyy hh:mm aa"
                                showTimeInput
                                className='form-control'
                                disabled={CSSdisabled == false ? "" : "disabled"}
	                        />

                        </div>

                    </div>

                    <div className="row mt-6">

                        <div className="col-md-2 pe-0 text-md-end">
                            <label className='col-form-label'>Consignee :</label>
                        </div>
                        <div className="col-md-6">
                            <input type='text' id='txtConsignee' maxLength={100} disabled={CSSdisabled} value={this.state.BookingDetails.Consignee} onChange={e => this.ConsigneeChange(e)} className='form-control' title={this.state.BookingDetails.Consignee} />
                        </div>

                        <div className="col-md-1 pe-0 text-md-end">
                            <label className='col-form-label'>ETA :</label>
                        </div>
                        <div className="col-md-3 width22">
                            <DatePicker
                                selected={this.state.BookingDetails.VesselETA == null ? null : new Date(this.state.BookingDetails.VesselETA)}
		                        onChange={this.ETADateChange.bind(this)}
		                        timeInputLabel="Time:"
                                showYearDropdown
                                yearDropdownItemNumber={5}
		                        dateFormat="MM/dd/yyyy hh:mm aa"
                                showTimeInput
                                className='form-control'
                                disabled={CSSdisabled == false ? "" : "disabled"}
	                        />                           

                        </div>


                    </div>

                    <div className="row mt-6">

                        <div className="col-md-2 pe-0 text-md-end">
                            <label className='col-form-label'>Contract Party :</label>
                        </div>
                        <div className="col-md-6">
                            <input type='text' id='txtContractParty' maxLength={100} disabled={CSSdisabled} value={this.state.BookingDetails.ContractParty} onChange={e => this.ContractPartyChange(e)} className='form-control' title={this.state.BookingDetails.ContractParty} />
                        </div>
                        <div className="col-md-1 pe-0 text-md-end">
                            <label className='col-form-label'>POR :</label>
                        </div>
                        <div className="col-md-3 width22">
                            <input type='text' id='txtPOR' maxLength={30} disabled={CSSdisabled} value={this.state.BookingDetails.POR} onChange={e => this.PORChange(e)} className='form-control' />
                        </div>
                    </div>

                    <div className="row mt-6">

                        <div className="col-md-2 pe-0 text-md-end">
                            <label className='col-form-label'>Agent :</label>
                        </div>
                        <div className="col-md-6">
                            <input type='text' id='txtAgent' maxLength={100} disabled={CSSdisabled} value={this.state.BookingDetails.Agent} onChange={e => this.AgentChange(e)} className='form-control' />


                        </div>


                        <div className="col-md-1 pe-0 text-md-end">
                            <label className='col-form-label'>POL :</label>
                        </div>
                        <div className="col-md-3 width22">
                            <input type='text' id='txtPOL' maxLength={30} disabled={CSSdisabled} value={this.state.BookingDetails.POL} onChange={e => this.POLChange(e)} className='form-control' />
                        </div>


                    </div>

                    <div className="row mt-6">

                        <div className="col-md-2 pe-0 text-md-end">
                            <label className='col-form-label'>Forwarder :</label>
                        </div>
                        <div className="col-md-6">
                            <input type='text' id='txtForwarder' maxLength={100} disabled={CSSdisabled} value={this.state.BookingDetails.Forwarder} onChange={e => this.ForwarderChange(e)} className='form-control' title={this.state.BookingDetails.Forwarder} />
                        </div>
                        <div className="col-md-1 pe-0 text-md-end">
                            <label className='col-form-label'>POD :</label>
                        </div>
                        <div className="col-md-3 width22">
                            <input type='text' id='txtPOD' maxLength={30} disabled={CSSdisabled} value={this.state.BookingDetails.POD} onChange={e => this.PODChange(e)} className='form-control' />
                        </div>



                    </div>


                    <div className="row mt-6">

                        <div className="col-md-2 pe-0 text-md-end">
                            <label className='col-form-label'>Consolidation :</label>
                        </div>
                        <div className="col-md-6">
                            <input type='text' id='txtConsolidation' maxLength={100} disabled={CSSdisabled} value={this.state.BookingDetails.Consolidation} onChange={e => this.ConsolidationChange(e)} className='form-control' title={this.state.BookingDetails.Consolidation} />
                        </div>

                        <div className="col-md-1 pe-0 text-md-end">
                            <label className='col-form-label'>DEL :</label>
                        </div>
                        <div className="col-md-3 width22">
                            <input type='text' id='txtDEL' maxLength={30} disabled={CSSdisabled} value={this.state.BookingDetails.DEL} onChange={e => this.DELChange(e)} className='form-control' />
                        </div>

                    </div>

                    <div className="row mt-6">

                        <div className="col-md-2 pe-0 text-md-end">
                            <label className='col-form-label'>Notify :</label>
                        </div>
                        <div className="col-md-6">
                            <input type='text' id='txtNotify' maxLength={100} disabled={CSSdisabled} value={this.state.BookingDetails.Notify} onChange={e => this.NotifyChange(e)} className='form-control' title={this.state.BookingDetails.Notify} />
                        </div>

                    </div>

                    <div className="row mt-6">
                        <div className="col-md-2 pe-0 text-md-end">
                            <label className='col-form-label'>BL Number :</label>
                        </div>
                        <div className="col-md-6">
                            <input type='text' id='txtBLNumber' maxLength={20} disabled={CSSdisabled} value={this.state.BookingDetails.BLNumber} onChange={e => this.BLNumberChange(e)} className='form-control' />
                        </div>

                    </div>
                    <div className="row mt-2">
                        <div className="col-md-2 pe-0 text-md-end">
                            <span className='col-form-label'>Customer :</span>
                        </div>
                        <div className="col-md-6">
                            <input type='text' id='txtCustomer' maxLength={100} disabled={CSSdisabled} value={this.state.BookingDetails.BKCustomer} onChange={e => this.BLCustomerChange(e)} className='form-control' />
                        </div>

                    </div>

                    <div className="row">

                        <div className="col-md-12 px-0">

                            <hr className="HorizentalLine hide" />
                        </div>

                    </div>

                    <div className="row mt-6" hidden={true}>
                        <div className="col-md-2 pe-0 text-md-end"><label className='col-form-label'>Departing VVC: </label></div>
                        <div className="col-md-2">
                            <Autosuggest name="vesselID" id="vesselID"
                                suggestions={suggestionsVesselId}
                                onSuggestionsFetchRequested={this.onSuggestionsFetchRequestedforvessel}
                                onSuggestionsClearRequested={this.onSuggestionsClearRequestedforvessel}
                                getSuggestionValue={this.getSuggestionVesselValue}
                                renderSuggestion={this.renderSuggestionVesselvalue}
                                inputProps={FenceIdListinputPropsforvessel}
                                highlightFirstSuggestion={true}
                            />
                        </div>

                        <div className="col-md-2">
                            <Autosuggest name="voyage" id="voyage"
                                suggestions={suggestionsVoyage}
                                onSuggestionsFetchRequested={this.onSuggestionsFetchRequestedforvoyage}
                                onSuggestionsClearRequested={this.onSuggestionsClearRequestedforvoyage}
                                getSuggestionValue={this.getSuggestionvoyageValue}
                                renderSuggestion={this.renderSuggestionvoyagevalue}
                                inputProps={FenceIdListinputPropsforvoyage}
                                highlightFirstSuggestion={true}
                            />
                        </div>

                        <div className="col-md-2">
                            <Autosuggest name="Call" id="Call"
                                suggestions={suggestionsCalls}
                                onSuggestionsFetchRequested={this.onSuggestionsFetchRequestedforcall}
                                onSuggestionsClearRequested={this.onSuggestionsClearRequestedforcall}
                                getSuggestionValue={this.getSuggestioncallValue}
                                renderSuggestion={this.renderSuggestioncallvalue}
                                inputProps={FenceIdListinputPropsforcall}
                                highlightFirstSuggestion={true}
                            />
                        </div>

                    </div>
                    <div className="row mt-6" hidden={true}>
                        <div className="col-md-2 pe-0 text-md-end"><label className='col-form-label'>Arriving VVC: </label></div>
                        <div className="col-md-2">
                            <Autosuggest name="ArrvesselID" id="ArrvesselID"
                                suggestions={ArrsuggestionsVesselId}
                                onSuggestionsFetchRequested={this.onSuggestionsFetchRequestedforArrvessel}
                                onSuggestionsClearRequested={this.onSuggestionsClearRequestedforArrvessel}
                                getSuggestionValue={this.getSuggestionArrVesselValue}
                                renderSuggestion={this.renderSuggestionArrVesselvalue}
                                inputProps={FenceIdListinputPropsforArrvessel}
                                highlightFirstSuggestion={true}
                            />
                        </div>

                        <div className="col-md-2">
                            <Autosuggest name="Arrvoyage" id="Arrvoyage"
                                suggestions={ArrsuggestionsVoyage}
                                onSuggestionsFetchRequested={this.onSuggestionsFetchRequestedforArrvoyage}
                                onSuggestionsClearRequested={this.onSuggestionsClearRequestedforArrvoyage}
                                getSuggestionValue={this.getSuggestionArrvoyageValue}
                                renderSuggestion={this.renderSuggestionArrvoyagevalue}
                                inputProps={FenceIdListinputPropsforArrvoyage}
                                highlightFirstSuggestion={true}
                            />
                        </div>

                        <div className="col-md-2">
                            <Autosuggest name="ArrCall" id="ArrCall"
                                suggestions={ArrsuggestionsCalls}
                                onSuggestionsFetchRequested={this.onSuggestionsFetchRequestedforArrcall}
                                onSuggestionsClearRequested={this.onSuggestionsClearRequestedforArrcall}
                                getSuggestionValue={this.getSuggestionArrcallValue}
                                renderSuggestion={this.renderSuggestionArrcallvalue}
                                inputProps={FenceIdListinputPropsforArrcall}
                                highlightFirstSuggestion={true}
                            />
                        </div>
                    </div>
                </div>
            </div>

        </div>
    }
}